<template>
  <v-dialog v-model="dialog.display" persistent  max-width="550px">
    <v-card>
      <v-card-title>
        <span class="text-subtitle-2">
          <span class="font-weight-bold secondary-font">{{
            dialog.title
          }}</span>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-7 pt-3">
        <v-text-field
          v-model="form.identifier"
          :label="$t('commons.fields.identifier.title')"
          append-icon="mdi-identifier"
          dense
          @input="delayTouch($v.form.identifier)"
          @blur="$v.form.identifier.$touch()"
          :error-messages="errorsIdentifier"
          class="mb-3"
          maxlength="50"
          :disabled="cga.id ? true : false"
        ></v-text-field>
        <v-text-field
          v-model="form.username"
          :label="$t('commons.fields.username.title')"
          append-icon="mdi-account-outline"
          dense
          @input="delayTouch($v.form.username)"
          @blur="$v.form.username.$touch()"
          :error-messages="errorsUsername"
          class="mb-3"
          maxlength="50"
        ></v-text-field>
        <v-text-field
          v-model="form.password"
          :label="$t('commons.fields.password.title')"
          append-icon="mdi-lock-outline"
          dense
          @input="delayTouch($v.form.password)"
          @blur="$v.form.password.$touch()"
          :error-messages="errorsPassword"
          class="mb-3"
          maxlength="50"
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="mt-0 px-5">
        <v-spacer></v-spacer>
        <v-btn text @click="cancel()">{{ $t("btn.cancel") }}</v-btn>
        <v-btn text color="primary" class="font-weight-bold" @click="save()">{{
          cga.id ? $t("btn.update") : $t("btn.save")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import FormDelayMixin from "./../../../mixins/commons/form-delay-touch";
import FormMixin from "./../../../mixins/commons/form";
export default {
  props: {
    dialog: {
      type: Object,
      default: function() {
        return {
          display: false,
          title: null,
        };
      },
    },
    cga: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  mixins: [FormDelayMixin, FormMixin],
  created() {
    this.initForm();
  },
  watch: {
    "dialog.display": function(val) {
      if (val) {
        this.initForm();
      }
    },
  },
  validations() {
    return {
      form: {
        identifier: {
          required,
          matchIdentifier: (value) => {
            if (!helpers.req(value)) return true;

            return /^[0-9a-z_-]+$/i.test(value);
          },
          maxLength: maxLength(50),
        },
        username: {
          required,
          maxLength: maxLength(50),
        },
        password: {
          required,
          maxLength: maxLength(50),
        },
      },
    };
  },
  data: () => ({
    form: {
      identifier: null,
      username: null,
      password: null,
    },
    loading: {
      save: false,
    },
  }),
  methods: {
    initForm() {
      this.form = {
        identifier: this.cga?.identifier || null,
        username: this.cga?.username || null,
        password: this.cga?.password || null,
      };
    },
    getPath() {
      return this.cga.id
        ? `/api/cga-manager/${this.cga.id}`
        : "/api/cga-manager";
    },
    getMessages() {
      return {
        200: this.$t("cga.manager.edit.success"),
        201: this.$t("cga.manager.add.success"),
        403: true,
        400: true,
        422: (error) => {
          if (error.code === "P01") {
            return this.$t("cga.manager.fields.identifier.exists");
          }
        },
        500: true,
      };
    },
    preSubmit() {
      this.loading.save = true;
    },
    postSubmit(response, error) {
      this.loading.save = false;
      if (!error) {
        this.dialog.display = false;
        this.resetForm();
      }
    },
    getMethod() {
      return this.cga.id ? "PUT" : "POST";
    },
    resetForm() {
      this.form = { identifier: null, username: null, password: null };
      this.$v.form.$reset();
    },
    cancel() {
      this.form = { identifier: null, username: null, password: null };
      this.$v.form.$reset();
      this.dialog.display = false;
    },
  },
  computed: {
    errorsIdentifier() {
      const errors = [];

      if (!this.$v.form.identifier.$dirty) return errors;

      !this.$v.form.identifier.required &&
        errors.push(this.$t("commons.fields.identifier.required"));
      !this.$v.form.identifier.maxLength &&
        errors.push(
          this.$t("commons.fields.identifier.max_length", {
            max: this.$v.form.identifier.$params.maxLength.max,
          })
        );

      !this.$v.form.identifier.matchIdentifier &&
        errors.push(this.$t("cga.manager.fields.identifier.invalid"));

      return errors;
    },
    errorsUsername() {
      const errors = [];

      if (!this.$v.form.username.$dirty) return errors;

      !this.$v.form.username.required &&
        errors.push(this.$t("commons.fields.username.required"));
      !this.$v.form.username.maxLength &&
        errors.push(
          this.$t("commons.fields.username.max_length", {
            max: this.$v.form.username.$params.maxLength.max,
          })
        );

      return errors;
    },
    errorsPassword() {
      const errors = [];

      if (!this.$v.form.password.$dirty) return errors;

      !this.$v.form.password.required &&
        errors.push(this.$t("commons.fields.password.required"));
      !this.$v.form.password.maxLength &&
        errors.push(
          this.$t("commons.fields.password.max_length", {
            max: this.$v.form.password.$params.maxLength.max,
          })
        );

      return errors;
    },
  },
};
</script>
